import { Controller } from "@hotwired/stimulus";

// Shows a live preview of the chosen file in the avatar circle before the
// form is submitted, swapping out the placeholder/current image.
export default class extends Controller {
  static targets = ["input", "image", "placeholder"];

  preview() {
    const file = this.inputTarget.files[0];
    if (!file) return;

    const previousUrl = this.hasImageTarget ? this.imageTarget.src : null;

    if (this.hasImageTarget) {
      this.imageTarget.src = URL.createObjectURL(file);
      this.imageTarget.hidden = false;
    }

    if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = true;

    if (previousUrl && previousUrl.startsWith("blob:")) {
      URL.revokeObjectURL(previousUrl);
    }
  }
}
